import React, { Component } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import heic2any from "heic2any";
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { Alert } from "../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:사업자 등록증 업로드
 * 세부설명:
*/

export class SimpleFileUpLoad extends Component {
    static displayName = SimpleFileUpLoad.name;
    static PageComplete = false;
    constructor(props) {
        super(props);
        this.state = {
            showBackdrop: false,
            upLoadStart: false,
            ImageList: [],
            Content: ""
        };
        this.hiddenFileInput = React.createRef();
        this.handleFileSearchClick = this.handleFileSearchClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFileServerSend = this.handleFileServerSend.bind(this);
        this.handleAlert_Clik = this.handleAlert_Clik.bind(this);
    }
    //초기화
    componentDidMount() {
        console.log(this.props);         
    }
    handleFileSearchClick() {
        this.hiddenFileInput.current.click();
    }   
    TempFileList = [];
    TempImageList = [];
    handleChange(event) {
       
        this.TempFileList = event.target.files;
        if (this.TempFileList.length > 0 && !this.TempFileList[0].type.includes(Big3Common.BaseFileUpLoadConfig.FileType) && this.TempFileList[0].type !=="") {
            this.TempImageList = [];
            this.setState({
                Content: "이미지 파일만 등록 가능합니다."
            });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        this.setState({
            "showBackdrop": true
        });
        this.TempImageList = this.state.ImageList;
        this.FileHandler(0);
        return false;
    }
    handleAlert_Clik() {
        if (SimpleFileUpLoad.PageComplete) {
            if (this.props.ComponentName !== undefined && this.props.ComponentName !== null) {
                //매장정보 변경에서 호출
                let ComponentName = this.props.ComponentName;
                if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
                    let ContentState = this.props.ContentState;
                    this.props.RenderComponent(ComponentName, ContentState);
                }
                else {
                    this.props.RenderComponent(ComponentName);
                }
            }
        }
        return false;
    }
    FileHandler(idx) {
        let _this = this;
        let FileList = _this.TempFileList
        let ImageList = _this.TempImageList;
      
        //#################재귀호출 종료
        if (FileList.length <= idx) {
            //처리
            this.setState({
                "showBackdrop": false,
                "ImageList": _this.TempImageList,
                "Content": "",
                "Title": "",
            });
            return false;
        }
        else {

            let SelectFile = FileList[idx];
            let Seq = ImageList.length > 0 ? ImageList[ImageList.length - 1].Seq : 0;
            let reader = new FileReader();

            if (SelectFile.name.toLowerCase().includes(".heic")) {
                //heic 파일(아이폰) 이미지 포멧 처리
                heic2any({ blob: SelectFile, toType: "image/jpeg" }).then(function (resultBlob) {
                    SelectFile = new File([resultBlob], SelectFile.name.split('.')[0] + ".jpg", { type: "image/jpeg", lastModified: new Date().getTime() });
                    reader.addEventListener('load', function (event) {
                        if (event.type === "load") {
                            let ImageProps = {
                                Seq: (Seq) + 1,
                                Url: this.result,
                                Size: SelectFile.size,
                                Name: SelectFile.name,
                                Type: SelectFile.type,
                                Crud: "C",
                                Guid: Big3Common.getGuid()
                            };
                            _this.TempImageList = [];
                            _this.TempImageList.push(ImageProps);
                        }
                    }, false);
                    reader.addEventListener('loadend', function (event) {
                        if (event.type === "loadend") {
                            //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                            _this.FileHandler((idx + 1));
                        }
                    });
                    reader.readAsDataURL(SelectFile);
                });
            }
            else {
                //표준 이미지 포멧 처리
                reader.addEventListener('load', function (event) {
                    if (event.type === "load") {
                        let ImageProps = {
                            Seq: (Seq) + 1,
                            Url: this.result,
                            Size: SelectFile.size,
                            Name: SelectFile.name,
                            Type: SelectFile.type,
                            Crud: "C",
                            Guid: Big3Common.getGuid()
                        };
                        _this.TempImageList = [];
                        _this.TempImageList.push(ImageProps);
                    }
                }, false)
                reader.addEventListener('loadend', function (event) {
                    if (event.type === "loadend") {
                        //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                        _this.FileHandler((idx + 1));
                    }
                });
                reader.readAsDataURL(SelectFile);
            }
        }
        this.setState({ upLoadStart: true });
        return false;
    }
    async handleFileServerSend() {
        if (this.state.upLoadStart !== true) return false;

        //업로드 파일 사이즈
        let ImageUpLoadSize = Big3Common.BaseFileUpLoadConfig.FileSize;
        let UpLoadList = this.state.ImageList;
        //파일 사이즈 검증
        let overFileSize = UpLoadList.filter(list => list.Size > ImageUpLoadSize);
        if (overFileSize.length > 0) {
            let overSizeName = overFileSize[0].Name;
            let overSize = overFileSize[0].Size;
            overSize = Math.round((overSize) / 1024);
            let content = `첨부파일  ${overSizeName}는 업로드 최대용량(${(ImageUpLoadSize) / 1024}Kb)을 초과 했습니다.\n현재 파일 사이즈는 ${overSize}Kb입니다.`;
            this.setState({ Content: content });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (UpLoadList.length === 0) {
            let content = '업로드할 파일이 없습니다.';
            this.setState({ Content: content });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
         
        //파일 업로드 시작
        this.setState({ showBackdrop: true });
        await UpLoadList.map(async (list) => {
            let result = await Big3Common.FileUpLoadModule(Big3Common.BaseFileUpLoadConfig.UpLoadUrl, {
                FileSeq: list.Seq,
                BlobData: list.Url,
                FileSize: list.Size,
                FileName: list.Name,
                FileType: list.Type,
                CrudType: list.Crud,
                Guid: list.Guid,
                Storage: Big3Common.BaseFileUpLoadConfig.FileStoragePath
            });

            let content = '';            
            if (!result) {
                content = '업로드중 에러가 발생하였습니다. 담당자에 문의 부탁드립니다.';    
                this.setState({ upLoadStart: false, showBackdrop: false, Content: content });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
                //업로드 완료되면 파일정보를 DB에 저장
                let FileMst = {
                    file_no: list.Guid,
                    file_nm: list.Name,
                    file_size: list.Size,
                    uplcomp_yn: "N",
                    ord_by: "1"
                }
                let Data = await Big3Common.Post(Big3Common.BaseFileUpLoadConfig.RestUrl, FileMst);   
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    content = '업로드 완료되었습니다.';
                    Big3Common.WebStorage.SetSessionStorage(Big3Common.WebStorage.StorageName.FileGrpKey, Data.objectData);
                    SimpleFileUpLoad.PageComplete = true;
                }
                else {
                    content = Data.message;
                }
                
                this.setState({ upLoadStart: false, showBackdrop: false, Content: content});
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            
            return false;
        });
    }
    //이미지 뷰어
    ImageShow() {
        if (this.state.ImageList.length > 0) {

            let ImageData = this.state.ImageList[0];
            if (ImageData.Type.includes("image")) {
                return (
                    <div className="file file_show"><img width="100%" height="100%" src={ImageData.Url} alt=''></img></div>
                );
            }
            else {
                return (
                    <div className="file file_show"></div>
                );
            }
            
        }
        else {
            return (
                <div className="file file_show item_hide"></div>
            );
        }
    }
    render() {
        let ImageShow = this.ImageShow();
        
        return (
            <form>
                <div className="file_box">
                    <div className="file file_upload">
                        <div className="plus" onClick={this.handleFileSearchClick}>
                            <input type="file" style={{ display: 'none' }}
                                ref={this.hiddenFileInput}
                                onChange={this.handleChange}
                                accept="image/png, image/gif, image/jpeg" 
                            />
                        </div>
                    </div>
                    {ImageShow }
                </div>
                <div className="button_line bottom_line">
                    <button type="button"
                        className={this.state.upLoadStart === true ? "btn_v  btn_v1" : "btn_v  btn_inactive"}
                        onClick={this.handleFileServerSend}
                    >완료</button>
                </div>
                <div>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.showBackdrop}
                    >
                    <CircularProgress color="inherit" />
                    </Backdrop>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="파일 업로드안내"
                    AlertClick={this.handleAlert_Clik }
                />
            </form>
        );
    }
}
